import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { AuthShell } from "./AuthShell";
import { ArrowRight } from "lucide-react";
import { api, formatError } from "@/api";
import { useAuth } from "@/auth";
import { toast } from "sonner";

export default function GoogleRoleSelect() {
  const navigate = useNavigate();
  const { user, setUser, loading } = useAuth();

  useEffect(() => {
    if (!loading && user === false) navigate("/kirjaudu", { replace: true });
    if (user && user.role) navigate("/dashboard", { replace: true });
  }, [user, loading, navigate]);

  const choose = async (role) => {
    try {
      const { data } = await api.post("/auth/set-role", { role });
      setUser(data);
      toast.success("Rooli valittu! Täydennä profiilisi aloittaaksesi.");
      navigate("/dashboard/profiili", { replace: true });
    } catch (err) {
      toast.error(formatError(err.response?.data?.detail));
    }
  };

  const Btn = ({ onClick, testid, title, desc }) => (
    <button onClick={onClick} data-testid={testid}
      className="w-full text-left rounded-2xl border border-[#E6E1D9] p-6 transition-colors hover:border-[#292827] group">
      <div className="flex items-center justify-between gap-4">
        <div>
          <h3 className="text-[17px] font-semibold tracking-tightish text-[#292827]">{title}</h3>
          <p className="text-sm text-[#6E675C] mt-1">{desc}</p>
        </div>
        <ArrowRight size={20} className="text-[#968F85] group-hover:text-[#292827] group-hover:translate-x-1 transition-all shrink-0" />
      </div>
    </button>
  );

  return (
    <AuthShell title="Melkein valmista" subtitle="Valitse roolisi jatkaaksesi." testid="google-role-page">
      <div className="space-y-3">
        <Btn onClick={() => choose("creator")} testid="google-role-creator" title="Olen sisällöntuottaja" desc="Hae avoimiin kampanjoihin." />
        <Btn onClick={() => choose("business")} testid="google-role-business" title="Rekisteröidy yrityksenä" desc="Julkaise kampanjoita." />
      </div>
    </AuthShell>
  );
}
